import { isUndefined, pick } from 'lodash'
import create from 'zustand'

import { FolderClient } from 'api/clients/FolderClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { AlmanacFile } from 'types'
import { reportError } from 'utils/error'

export type Store = {
  currentFolder: AlmanacFile | null
  editingName: boolean
  setCurrentFolder: (currentFolder: AlmanacFile | null) => void
  setEditingName: (editingName: boolean) => void
  reload: () => void
  update: (params: { title: string; emoji?: string | null }, opts?: { onSuccess?: () => void }) => void
}

const useCurrentFolderStore = create<Store>((set, get) => ({
  currentFolder: null,
  editingName: false,
  setCurrentFolder: (currentFolder: AlmanacFile | null) => set({ currentFolder }),
  setEditingName: (editingName: boolean) => set({ editingName }),
  reload: async () => {
    const folder = get().currentFolder
    if (!folder) return
    const res = await FolderClient.getFolder(folder.id)
    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      reportError('Cannot reload current folder', { metaData: folder })
      return
    }
    set({ currentFolder: res.data.folder })
  },
  update: async (params: { title: string; emoji?: string | null }, { onSuccess }: { onSuccess?: () => void } = {}) => {
    const folder = get().currentFolder
    if (!folder) return

    const emoji = isUndefined(params.emoji) ? folder.header_emoji : params.emoji

    // Optimistic update
    set({ currentFolder: { ...folder, title: params.title, header_emoji: emoji } })

    const res = await FolderClient.updateFolder(folder.id, pick(params, ['title', 'emoji']))

    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      reportError('Cannot update current folder', { metaData: { folder, params } })
      set({ currentFolder: folder })
      return
    } else {
      onSuccess?.()
    }
  },
}))

export { useCurrentFolderStore }
